import { Component, Input } from '@angular/core';

@Component({
  selector: 'nns-folder-empty',
  template: `
    <div class="nns-empty-folder-content" flex layout="column" layout-align="center center">
      <div class="nns-empty-folder-title" flex="none">Empty folder</div>
    </div>
  `,
  styles: [`
    .nns-empty-folder-content {
      text-align: center;
      padding: 16px;
    }
    .nns-empty-folder-icon {
      padding: 0 0 17px 0;
    }
    .nns-empty-folder-icon svg{
      width: 150px;
      height: 150px;
    }
    .nns-empty-folder-title {
      font-size: 24px;
      font-weight: bold;
      line-height: 1.4;
    }
  `]
})

export class FolderEmptyComponent {
  @Input() visual;

  constructor() {
    return;
  }
}
